import Loadable from "react-loadable";

const LazyCcListing = Loadable({
  loader: () => import(/* webpackChunkName: 'comite-carrire-listing-consultants' */ "./index"),
  loading: () => 'loading...'
});

export default LazyCcListing;
